import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconOpenWidth = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.83073 6.00033H9.16406V3.33366H11.1641L8.85095 1.02055C8.65569 0.825284 8.3391 0.825283 8.14384 1.02055L5.83073 3.33366H7.83073V6.00033ZM6.4974 7.33366H3.83073V5.33366L1.51762 7.64677C1.32235 7.84203 1.32235 8.15862 1.51762 8.35388L3.83073 10.667V8.66699H6.4974V7.33366ZM15.4772 8.35388C15.6724 8.15862 15.6724 7.84203 15.4772 7.64677L13.1641 5.33366V7.33366H10.4974V8.66699H13.1641V10.667L15.4772 8.35388ZM9.16406 10.0003H7.83073V12.667H5.83073L8.14384 14.9801C8.3391 15.1754 8.65569 15.1754 8.85095 14.9801L11.1641 12.667H9.16406V10.0003Z",
		fill: "#959595"
	})
});
export default SvgIconOpenWidth;
